import { ConversationProps } from '../../types';

// NOTE: This logic will be replaced once the MT side API is finished

const key = 'conversationData';

const saveConversation = (conversationToken: string, title: string) => {
  const newConversation = {
    id: conversationToken,
    title,
    date: new Date(Date.now()),
  };

  const existingConversations: ConversationProps = (() => {
    try {
      return JSON.parse(sessionStorage.getItem(key) || '[]') as ConversationProps;
    } catch {
      return [];
    }
  })();

  // Check if the conversation already exists based on the id
  const isConversationExists = existingConversations.some(
    (conversation) => conversation.id === newConversation.id,
  );

  // Add the new conversation to the array if it doesn't already exist
  if (!isConversationExists) {
    existingConversations.push(newConversation);
  }

  // Save the updated array back to sessionStorage
  window.sessionStorage.setItem('conversationData', JSON.stringify(existingConversations));
};

export default saveConversation;
